import { render, staticRenderFns } from "./CheckAge.vue?vue&type=template&id=1af6545e&"
import script from "./CheckAge.vue?vue&type=script&lang=js&"
export * from "./CheckAge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JVolke\\Documents\\plentyDevTool\\38722\\18\\KrauseSohn\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1af6545e')) {
      api.createRecord('1af6545e', component.options)
    } else {
      api.reload('1af6545e', component.options)
    }
    module.hot.accept("./CheckAge.vue?vue&type=template&id=1af6545e&", function () {
      api.rerender('1af6545e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/checkout/CheckAge.vue"
export default component.exports